import { render, staticRenderFns } from "./CarHealthBookAppointmentButton.vue?vue&type=template&id=0cd7ed4c&"
import script from "./CarHealthBookAppointmentButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CarHealthBookAppointmentButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports